"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Label_1 = __importDefault(require("../Label"));
var Badge_1 = require("../Badge");
function Item(_a) {
    var children = _a.children, Icon = _a.icon, _b = _a.active, active = _b === void 0 ? false : _b, onClick = _a.onClick, subItem = _a.subItem, label = _a.label, badge = _a.badge, _c = _a.disabled, disabled = _c === void 0 ? false : _c;
    var wrapperClass = (0, classnames_1.default)("nimbus--menu-item-wrapper", {
        "nimbus--menu-item--active": active,
        "nimbus--menu-item--disabled": disabled,
    });
    var renderLabel = label && (React.createElement(Label_1.default, { id: label.id, appearance: label.appearance, icon: label.icon, label: label.label }));
    var renderBadge = badge && React.createElement(Badge_1.Badge, { label: badge.label });
    return (React.createElement("div", { className: wrapperClass },
        React.createElement("button", { type: "button", onClick: !disabled ? onClick : undefined, className: "nimbus--menu-item" },
            React.createElement(Icon, null),
            React.createElement("span", { className: "nimbus--menu-item__label" }, children),
            renderLabel,
            renderBadge),
        subItem && (React.createElement("div", { className: "nimbus--menu-sub-item-wrapper" }, subItem === null || subItem === void 0 ? void 0 : subItem.map(function (item, index) {
            var subItemClass = (0, classnames_1.default)("nimbus--menu-sub-item", {
                "nimbus--menu-sub-item--active": item.active,
            });
            var renderSubItemLabel = item.label && (React.createElement(Label_1.default, { id: item.label.id, appearance: item.label.appearance, icon: item.label.icon, label: item.label.label }));
            var renderSubItemBadge = item.badge && (React.createElement(Badge_1.Badge, { label: item.badge.label }));
            return (React.createElement("button", { key: index, type: "button", onClick: item.onClick, className: subItemClass },
                React.createElement("span", { className: "nimbus--menu-item__label" }, item.children),
                renderSubItemLabel,
                renderSubItemBadge));
        })))));
}
exports.default = Item;
//# sourceMappingURL=Menu.Item.js.map